import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { FormService } from '../../services/form.service';

@Component({
  selector: 'app-button',
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
  standalone: true,
})
export class ButtonComponent {

  constructor(public fs: FormService) { }

  @Input() color: string = '';
  @Input() icon: any = '';
  @Input() label: string = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() icon_alignment: 'left' | 'right' = 'left';
  @Input() placement: 'header' | '' = '';
  @Input() disabled: boolean = false
  @Input() submit: (() => Promise<any>) | undefined;
  isLoading: boolean = false;

  async handleClick(event: MouseEvent) {
    if (this.submit && !this.disabled && !this.isLoading) {
      this.isLoading = true;
      try {
        await this.submit();
      } finally {
        this.isLoading = false;
      }
    }
  }
  cancel: any;
  confirm: any;

  on_cancel_click(): void {
    this.cancel.emit();
  }

  on_confirm_click(): void {
    this.confirm.emit();
  }
}
